if (!customElements.get('cinoton-newsletter-popup')) {
  class CinotonNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[role="dialog"]');
      this.lastFocus = null;
      this.launcher = this.closest('.shopify-section')?.querySelector('[data-popup-editor-launch]');
      this.handleLauncherClick = () => this.open();
      this.handleSectionSelect = () => this.open();
      this.launcher?.addEventListener('click', this.handleLauncherClick);
      this.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('button, input, a[href]')].filter((el) => !el.disabled && el.offsetParent !== null);
        if (!focusable.length) return;
        if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
        if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
      });
      const shouldOpen = this.querySelector('[data-popup-success]') || !sessionStorage.getItem('cinoton-newsletter-seen');
      if (shouldOpen && !window.Shopify?.designMode) {
        window.setTimeout(() => this.open(), Number(this.dataset.delay || 5000));
      }
      if (window.Shopify?.designMode) this.addEventListener('shopify:section:select', this.handleSectionSelect);
    }
    disconnectedCallback() {
      this.launcher?.removeEventListener('click', this.handleLauncherClick);
      this.removeEventListener('shopify:section:select', this.handleSectionSelect);
      document.body.classList.remove('cinoton-popup-open');
    }
    open() {
      this.lastFocus = document.activeElement;
      this.hidden = false;
      document.body.classList.add('cinoton-popup-open');
      this.querySelector('[data-popup-close]')?.focus();
      sessionStorage.setItem('cinoton-newsletter-seen', '1');
    }
    close() {
      this.hidden = true;
      document.body.classList.remove('cinoton-popup-open');
      this.lastFocus?.focus?.();
    }
  }
  customElements.define('cinoton-newsletter-popup', CinotonNewsletterPopup);
}
